export default {
    'Relieve': '紧急解除',
    'TaskBoard': '任务看板',
    'Operation': '物联操作',
    'Statistics': '统计',
    'Mine': '我的'
};
